<div class="layout" [class.layout--article]="layoutService.getIsArticle()">
    @if (headerViewService.options$ | async; as bannerOptions) {
        <div id="layout__top-banner">
            @if (bannerOptions.exists) {
                <website-top-banner
                    class="layout__top-banner"
                    [text]="bannerOptions.text"
                    [icon]="bannerOptions.icon"
                    [hasIcon]="bannerOptions.hasIcon"
                    [hasCloseButton]="bannerOptions.hasCloseButton"
                    [colorScheme]="bannerOptions.colorScheme"
                >
                </website-top-banner>
            }
        </div>
    }

    <div class="layout__header" [class.layout__header--static]="(headerService.state$ | async)?.disableStickiness">
        @if (layoutService.shouldRenderHeader()) {
            <app-rebranded-header></app-rebranded-header>
        }
    </div>

    <main class="layout__content view">
        <router-outlet></router-outlet>
    </main>

    @if (layoutService.hasFooterSecondary()) {
        @defer (hydrate on viewport) {
            <app-footer-secondary
                [footerSecondary]="layoutService.footerSecondaryData()"
                [colorScheme]="'white'"
            ></app-footer-secondary>
        }
    }

    <div class="layout__footer">
        @if (layoutService.footerVariant(); as footerVariant) {
            @if (layoutService.isKlaxoonFooter()) {
                @defer (hydrate on viewport) {
                    <app-klaxoon-footer
                        [colorScheme]="layoutService.footerColorScheme()"
                        [footerSettings]="layoutService.footerData()"
                    ></app-klaxoon-footer>
                }
            } @else if (footerVariant === 'full') {
                @defer (hydrate on viewport) {
                    <app-footer
                        [colorScheme]="layoutService.footerColorScheme()"
                        [footerSettings]="layoutService.footerData()"
                    ></app-footer>
                }
            } @else if (footerVariant === 'light') {
                @defer (hydrate on viewport) {
                    <app-light-footer [colorScheme]="layoutService.footerColorScheme()"></app-light-footer>
                }
            }
        }
    </div>

    @if (headerViewService.pinnedCtaOptions$ | async; as pinnedCtaData) {
        <div class="layout__pinned-cta">
            @if (pinnedCtaData.exists) {
                <app-pinned-cta [pinnedCtaData]="pinnedCtaData"></app-pinned-cta>
            }
        </div>
    }
</div>
